/** Known QuickBooks ShipMethodRef / delivery option values. */
export enum DeliveryType {
  SecondDayAir = "2nd Day Air",
  ThirdDayAir = "3rd Day Air",
  Collect = "Collect",
  CustPickup = "Cust Pickup",
  DirectDelivery = "Direct Delivery",
  FreightAllowed = "Freight Allowed",
  FreightEconomy = "Freight Economy",
  FreightPriorit = "Freight Priorit",
  Ground = "Ground",
  NA = "n/a",
  NoCharge = "No Charge",
  OurTruck = "Our Truck",
  Overnight = "Overnight",
  OvernightBy1030 = "Overnight by 10:30",
  OvernightByAM = "Overnight by AM",
  PickUpByRCS = "Pick up by RCS",
  PrepayAndAdd = "Prepay & Add",
  ThirdParty = "Third Party",
  VendorDeliver = "Vendor Deliver",
  VendorToRCS = "Vendor to RCS",
}

/** Seed / fallback delivery speeds (also seeded into catalog_types). */
export const DELIVERY_SPEED_OPTIONS: readonly string[] = [
  DeliveryType.Ground,
  DeliveryType.Overnight,
  DeliveryType.OvernightBy1030,
  DeliveryType.OvernightByAM,
  DeliveryType.SecondDayAir,
  DeliveryType.ThirdDayAir,
  DeliveryType.PickUpByRCS,
  DeliveryType.FreightAllowed,
  DeliveryType.FreightEconomy,
  DeliveryType.FreightPriorit,
];

/** Seed / fallback delivery methods (also seeded into catalog_types). */
export const DELIVERY_METHOD_OPTIONS: readonly string[] = [
  DeliveryType.Collect,
  DeliveryType.CustPickup,
  DeliveryType.DirectDelivery,
  DeliveryType.PrepayAndAdd,
  DeliveryType.OurTruck,
  DeliveryType.ThirdParty,
  DeliveryType.VendorDeliver,
  DeliveryType.VendorToRCS,
  DeliveryType.NoCharge,
  DeliveryType.NA,
];

/** @deprecated Prefer DELIVERY_SPEED_OPTIONS + DELIVERY_METHOD_OPTIONS */
export const DELIVERY_TYPE_OPTIONS: readonly DeliveryType[] = [
  ...DELIVERY_SPEED_OPTIONS,
  ...DELIVERY_METHOD_OPTIONS,
] as DeliveryType[];

const DELIVERY_TYPE_VALUE_SET = new Set<string>(Object.values(DeliveryType));
const DELIVERY_METHOD_VALUE_SET = new Set<string>(DELIVERY_METHOD_OPTIONS);
const DELIVERY_SPEED_VALUE_SET = new Set<string>(DELIVERY_SPEED_OPTIONS);

export function isDeliveryType(value: string): value is DeliveryType {
  return DELIVERY_TYPE_VALUE_SET.has(value);
}

export function isDeliveryMethodValue(value: string): boolean {
  return DELIVERY_METHOD_VALUE_SET.has(value);
}

export function isDeliverySpeedValue(value: string): boolean {
  return DELIVERY_SPEED_VALUE_SET.has(value);
}
